import React from "react";
import AdminModulePage from "../../../components/Admin/ModulePage/AdminModulePage";

const Reports = () => {
    return <AdminModulePage moduleKey="reports" />;
};

export default Reports;
